
angular.module('iconoglobe')
.service('metaHelper', ["$http", "$rootScope", "$window", "$location", "$filter", 
  function($http, $rootScope, $window, $location, $filter){
  
  var metaData;
  this.getMeta = function(){
    var that = this;
    $http.get("").then(function(res) {
      metaData = res.data;
      that.setMeta();    
    }, function(err) {
      console.log(err);
    });
  }
  
  this.setMeta = function(){
    if(metaData){
      var search = $window.location.search;
      search = search.split("&at");
      var urlPath = $location.path() + search[0];
   //   console.log(urlPath);
    
      var meta = $filter('filter')(metaData, { url: urlPath }, true);
  //    console.log(meta);
      if (meta.length > 0) {
        $rootScope.metaDescription = meta[0].description;
        $rootScope.metaKeywords = meta[0].keywords;
        $rootScope.metaTitle = meta[0].title;
      }
    } else{
      this.getMeta();
    }
  }
}]);
